import { useEffect } from "react";
import { Modal } from "bootstrap/dist/js/bootstrap.min";

function Info() {
    useEffect(() => {
        const myModal = new Modal(document.getElementById("infoModal"));
        myModal.show();
    });
    return (
        <>
            <div class="modal fade" id="infoModal" tabindex="-1">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h1 class="modal-title fs-5" id="exampleModalLabel">Modal title</h1>
                            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div class="modal-body">
                            ...
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            <button type="button" class="btn btn-primary">Save changes</button>
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
}

export default Info;